import LangBtn from './LangBtn';

export default LangBtn;
